import React, { FC } from 'react'

const DuplicateIcon: FC<{ className: string; fill?: string }> = ({ className, fill }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6 2H22V18H18V22H2V6H6V2ZM8 6H18V16H20V4H8V6ZM16 8H4V20H16V8ZM9 13V10H11V13H14V15H11V18H9V15H6V13H9Z'
        fill={fill ? fill : 'black'}
      />
    </svg>
  )
}

export default DuplicateIcon
